<template>
  <div class="main">
      <!-- 广告主资料 -->
    <div class="nav">广告主资料</div>
    <div class="content">
      <div class="series">
        <h4>申请类型</h4>
        <el-select class="goodsInput" v-model="applyType" placeholder="请选择申请类型">
          <el-option
            v-for="item in applyTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="title">
        <h4>商务管理平台编号</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入商务管理平台编号"></el-input>
      </div>
      <div class="series">
        <h4>广告主行业，子行业</h4>
        <el-select class="goodsInput" v-model="value" placeholder="请选择广告主行业，子行业">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="title">
        <h4>主要联系人</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入主要联系人"></el-input><span>（广告主联系人全名）</span>
      </div>
      <div class="title">
        <h4>主要联系人邮箱</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入主要联系人邮箱"></el-input>
      </div>
      <div class="title">
        <h4>主要联系人电话</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入主要联系人电话"></el-input>
      </div>
      <div class="title">
        <h4>公司正式用名（中文）</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入公司正式用名（中文）"></el-input><span>（必须和公司注册证书上的资料一样）</span>
      </div>
      <div class="title">
        <h4>法人代表</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入法人代表"></el-input><span>（需与注册证书上的一致）</span>
      </div>
      <div class="title">
        <h4>营业执照编号</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入营业执照编号"></el-input><span>（统一社会信用代码/注册号）</span>
      </div>
      <div class="title">
        <h4>注册地址（中文）</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入注册地址（中文）"></el-input><span>（必须和公司注册证书上的资料一样）</span>
      </div>
      <div class="title">
        <h4>广告主地址－国家（英文）</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入广告主地址－国家（英文）"></el-input>
      </div>
      <div class="title">
        <h4>广告主地址－邮政编码</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入广告主地址－邮政编码"></el-input>
      </div>
    </div>
    <!-- 广告账户详情 -->
    <div class="nav">广告账户详情</div>
    <div class="content">
      <div class="title">
        <h4>申请广告账号个数 （1--10）</h4>
         <el-input-number v-model="num" size="small" :min="1" :max="10" label="广告账号个数"></el-input-number>
      </div>
      <div class="title">
        <h4>Facebook主页链接</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请输入要推广的Facebook主页或网址，网页链接内容必须为外文"></el-input>
      </div>
      <div class="title">
        <h4>网站</h4>
        <div class="web">
            <el-input class="goodsInput" v-model="input" placeholder="请输入希望推广的网址"></el-input><span>网页链接内容必须为外文， 如果是app或游戏，则需要给出外文下载链接，必须是现实中来推广的网站）</span>
        </div>
      </div>
      <div class="title">
        <h4>应用</h4>
        <el-input class="goodsInput" v-model="input" placeholder="请填写要推广的应用编号，必须是现实中来推广的应用"></el-input>
      </div>
      <div class="series">
        <h4>账号应用时区</h4>
        <el-date-picker
            v-model="value1"
            type="datetime"
            placeholder="选择日期时间">
        </el-date-picker>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" size="small">确 定</el-button>
      <el-button size="small">取 消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  // name: "text",
  data() {
    return {
      input: "",
      applyTypes: [
        //申请类型
        {
          value: "选项1",
          label: "游戏"
        },
        {
          value: "选项2",
          label: "非游戏"
        }
      ],
      applyType: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      value1:"",
      num:1,
    };
  },
  methods: {},
  mounted() {},
  components: {}
};
</script>

<style lang="less" scoped>
.add {
  padding: 0;
  span {
    display: inline-block;
    padding: 0 20px;
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
}
.main {
  padding-top: 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  > .content {
    padding-left: 30px;
    margin-bottom: 30px;
    > .title,
    > .series {
      h4 {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 20px;
        margin-top: 10px;
      }
      .goodsInput {
        width: 500px;
        height: 40px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
      }
      > span {
        margin-left: 6px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aab2c0;
        line-height: 20px;
      }
    }
    > .series {
      .tags {
        display: flex;
        align-items: center;
      }
    }
  }
  > .nav {
    line-height: 24px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: 600;
  }
  .btn {
    margin-top: 26px;
    margin-bottom: 50px;
    text-align: center;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 150px;
  margin-left: 10px;
  vertical-align: bottom;
}
.main > .content > .series span[data-v-4a269b9c] {
  height: 26px;
  line-height: 26px;
}
.web{
    display: flex;
    align-items: center;
    >.goodsInput{
        width: 500px;
    }
    >span{
        flex: 1;
        margin-left: 10px;
        color: #aab2c0;
    }
}
</style>